import { createVisitor } from '@procommerce/visitor';
import { createStorefront, createViewResolver } from './app';

// noinspection JSIgnoredPromiseFromCall
createVisitor({
  resolve: createViewResolver,
  setup: (options) => {
    createStorefront(options).mount('#app');
  },
});
